import { Injectable } from '@angular/core';
import {Headers, RequestOptions} from '@angular/http';

@Injectable()
export class ESDashboardService { }


// WEBPACK FOOTER //
// ./src/app/elastic-search-dashboard/esDashboard.service.ts